export function constructSnippet(
  vertical: string,
  horizontal: string
): string {
  const parts = [
    vertical !== 'unset' ? vertical : null,
    horizontal !== 'unset' ? horizontal : null,
  ].filter(Boolean) as string[];

  if (parts.length === 0) {
    return `.target {
  position: absolute;
  position-anchor: --some-anchor;
  position-area: none;
}\
`;
  }

  return `.target {
  position: absolute;
  position-anchor: --some-anchor;
  position-area: ${parts.join(' ')};
}\
`;
}
